import axios from 'axios';

let cachedConfig = {
  HOST: null,
  BASE: null,
  TITLE: null,
  VAPID_PUB: null,
};

export async function loadConfigCache() {
  const { data } = await axios.get(window.location.origin + '/config.json').catch((error) => console.error('Failed to fetch config.json. The file not found. Error message:', error.message));
  if (data) {
    setConfigCache(data);
  }
} 

function setConfigCache(newConfig) {
  cachedConfig = { ...cachedConfig, ...newConfig };
}

export function getConfigCache() {
  return cachedConfig;
}